import { pb } from './pocketbase';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';


export const getApiKeys = async (partnerId) => {
    if (!pb.authStore.isValid) throw new Error('Utilisateur non connecté');
    if (!partnerId) throw new Error('partnerId est requis pour récupérer les clés API.');

    try {
        // Récupérer les clés API avec la nouvelle structure (partner_id + opco_id)
        let keys = await pb.collection('apikeys').getList(1, 50, {
            filter: `partner_id = "${partnerId}" && opco_id != ""`,
            expand: 'opco_id'
        });

        return keys.items;
    } catch (error) {
        console.error('Error fetching API keys:', error);
        throw error;
    }
};

export const getApiKeyByOpco = async (partnerId, opcoId) => {
    if (!pb.authStore.isValid) throw new Error('Utilisateur non connecté');
    if (!partnerId || !opcoId) {
        console.warn("getApiKeyByOpco called without partnerId or opcoId. Returning null.");
        return null;
    }
    try {
        // Récupérer la clé API avec la nouvelle structure (partner_id + opco_id)
        let records = await pb.collection('apikeys').getList(1, 1, {
            filter: `opco_id = "${opcoId}" && partner_id = "${partnerId}"`,
            expand: 'opco_id'
        });

        return records.items.length > 0 ? records.items[0] : null;
    } catch (error) {
        console.error(`Error fetching API key for OPCO ${opcoId} and Partner ${partnerId}:`, error);
        return null;
    }
};

export const updateApiKey = async (apiKeyId, apiKeyData) => {
    if (!pb.authStore.isValid) throw new Error('Utilisateur non connecté');
    const updatedRecord = await pb.collection('apikeys').update(apiKeyId, apiKeyData);
    console.log("Updated API key record:", updatedRecord);
    return updatedRecord;
};

export const createApiKey = async (apiKeyData) => {
    if (!pb.authStore.isValid) throw new Error('Utilisateur non connecté');
    
    const createdApiKey = await pb.collection('apikeys').create(apiKeyData);
    return createdApiKey;
};

export const saveApiKey = async (partnerId, opcoId, apikey, dateFinValidite = null) => {
    if (!pb.authStore.isValid) throw new Error('Utilisateur non connecté');
    if (!partnerId) throw new Error('partnerId est requis pour enregistrer une clé API.');

    try {
        const existingKey = await getApiKeyByOpco(partnerId, opcoId);

        const apiKeyData = { 
            apikey,
            ...(dateFinValidite && { date_fin_validite: dateFinValidite })
        };

        if (existingKey) {
            // Si la clé existe, la mettre à jour
            return await updateApiKey(existingKey.id, apiKeyData);
        } else {
            // Si la clé n'existe pas, la créer avec partner_id et opco_id
            return await createApiKey({ 
                partner_id: partnerId, 
                opco_id: opcoId, 
                ...apiKeyData 
            });
        }
    } catch (error) {
        console.error(`Error saving API key for OPCO ${opcoId} and Partner ${partnerId}:`, error);
        throw error;
    }
};

export const checkApiKey = async (partnerId, opcoId, apiKey) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/apikeys/check`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`  
      },
      body: JSON.stringify({ 
        partnerId, 
        opcoId, 
        apiKey 
      }),
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || errorData.message || 'Échec de vérification de la clé API');
    }
    
    // Traiter la réponse comme du JSON
    const result = await response.json();
    
    // Transformer la réponse pour le frontend
    return {
      isValid: result.success,
      message: result.message,
      centerInfo: result.data?.centerInfo,
      opcoTested: result.data?.opcoTested,
      apiKeyTested: result.data?.apiKeyTested,
      dateFinValidite: result.data?.dateFinValidite,
      status: result.data?.status,
      commentaire: result.data?.commentaire
    };
  } catch (error) {
    console.error('Erreur lors de la vérification de la clé API:', error);
    // Retourner un objet cohérent même en cas d'erreur
    return {
      isValid: false,
      message: error.message || 'Erreur lors de la vérification de la clé API'
    };
  }
};
